import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';


import { Person } from '../../../bo9-shared/models/person/person.model'
import { Router } from '@angular/router';
import { BO9UUID } from '../../../bo9-shared/models/UUID.model';

import { webAppVersion } from '../../../config/webapp.config';
import { LoginService } from '../../../services/loginservice/login.service';


@Component({
    selector: 'web-footer',
    templateUrl: './webfooter.component.html',
    styleUrls: ['./webfooter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WebFooterComponent implements OnInit {

  user: Person;

  version = webAppVersion;

  selectedOrg: BO9UUID;

  constructor(
    private auth: AuthService,
    private router: Router,

    private loginService: LoginService
  ) { }

  ngOnInit() {
    console.log('Init footer ');
   // this.user = this.auth.getAuthUser()!;
  }


}
